import _ from 'lodash';
import { DateTime, Time, UTCDate } from '@skyjs/date';

export default function getData(obj, options = {}) {
  _.defaults(options, { dateType: false, convertUndefinedToNull: false });

  if (_.isEmpty(obj)) return obj;

  const replacer = options.convertUndefinedToNull ? undefinedToNullReplacer : undefined;
  const cleanObj = replaceKnownTypeWithValueObjects(obj);
  const json = JSON.stringify(cleanObj, replacer);

  const reviver = options.dateType ? dateReviver : undefined;
  const data = JSON.parse(json, reviver);

  return data;
}

function replaceKnownTypeWithValueObjects(obj) {
  if (_.isArray(obj)) return _.map(obj, replaceKnownTypeWithValueObjects);
  if (obj instanceof UTCDate || obj instanceof DateTime) return obj;
  if (obj instanceof Time) return obj.toString();

  if (_.isObject(obj)) {
    if (obj.$type) return obj.$type.isEnum ? { value: obj.value } : obj;
    return _.mapValues(obj, replaceKnownTypeWithValueObjects);
  }
  return obj;
}

function undefinedToNullReplacer(key, value) {
  return value === undefined ? null : value;
}

function dateReviver(key, value) {
  if (isSerializedDate(value)) {
    const date = new UTCDate(value);
    return date.toISO() === value ? date : new DateTime(value);
  }

  if (isSerializedTime(value)) {
    return new Time(value);
  }

  return value;
}

const datePattern = /^\d{4}-\d{2}-\d{2}T[0-9:.\-Z]*$/;
const timePattern = /^\d{2}:\d{2}$/;

const isSerializedDate = value => _.isString(value) && datePattern.test(value);
const isSerializedTime = value => _.isString(value) && timePattern.test(value);
